import dayjs from 'dayjs';

export const SALESFORCE_TASK_MAX_COMMENTS_LENGTH = 32_000;

export const isSalesforceTaskCommentsTooLong = (comments = '') =>
	comments.trim().length > SALESFORCE_TASK_MAX_COMMENTS_LENGTH;

const getDueDateErrorMessage = ({ isEmpty, isInvalid, isPast, exceedsMax }) => {
	if (isEmpty) {
		return 'Due date is required';
	}

	if (isInvalid) {
		return 'Please enter a valid due date';
	}

	if (isPast) {
		return 'Due date cannot be in the past';
	}

	if (exceedsMax) {
		return 'Due date cannot be more than 1 year in the future';
	}

	return undefined;
};

export const validateSalesforceTaskDueDate = (
	value,
	allowExistingPastDate = null
) => {
	const minDate = dayjs().startOf('day');
	const maxDate = dayjs().add(1, 'year').endOf('day');

	const isEmpty = !value;
	const isInvalid = !!value && !value.isValid();

	const formattedValue = value?.isValid() ? value.format('YYYY-MM-DD') : null;

	const isPast =
		value?.isValid() &&
		value.isBefore(minDate, 'day') &&
		formattedValue !== allowExistingPastDate;

	const exceedsMax = value?.isValid() && value.isAfter(maxDate, 'day');

	const errorMessage = getDueDateErrorMessage({
		isEmpty,
		isInvalid,
		isPast,
		exceedsMax,
	});

	return {
		isValid: !errorMessage,
		errorMessage,
		formattedValue,
		minDate,
		maxDate,
	};
};
